import React from 'react';

function Footer() {
  return (
    <div className="container-fluid bg-dark footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-md-6">
            <h1 className="text-white mb-4"><img className="img-fluid me-3" src="/img/icon/icon-02-light.png" alt="" />Tama Service</h1>
            <span>Diseñamos, instalamos y mantenemos sistemas de flujo de aire según normativa <br />Damos Soluciones integrales para el confort y la eficiencia de tus instalaciones. Calidad, compromiso y tecnología al servicio de tu empresa.</span>
          </div>
          <div className="col-md-6">
                        <h5 className="text-light mb-6">Get In Touch</h5>
            <p><i className="fa fa-map-marker-alt me-3"></i>ANTONIO BELLET 193 OF 1210, PROVIDENCIA</p>
            <p><i className="fa fa-phone-alt me-3"></i>+56 9 45474366</p>
            <p><i className="fa fa-envelope me-3"></i>contacto@tamaservice.cl</p>
          </div>
          <div className="col-lg-12 col-md-12">

          </div>
          
        </div>
      </div>
      <div className="container-fluid copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              &copy; <a href="#">Tama Service</a>, All Right Reserved.
            </div>
            <div className="col-md-6 text-center text-md-end">
              Designed By <a href="https://www.tamaservice.cl">Alejandro Castro</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;